import { LOGIN } from "../configs/routes";
import {
  AccountLockedError,
  ActivationRequiredError,
  getApiErrorDetail,
} from "../utils/authErrors";
import api from "./api";

export const login = async (body) => {
  try {
    const response = await api.post(LOGIN, body);
    return response.data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = getApiErrorDetail(err);
    if (status === 402) throw new ActivationRequiredError(detail);
    if (status === 403) throw new AccountLockedError(detail);
    throw err;
  }
};

export { getApiErrorDetail };
